"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetailsPage = exports.AddOnsTableColumns = exports.PROMOTION_DURATION = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var upload_file_1 = require("../../../../api/calls/media/upload_file");
var get_product_1 = require("../../../../api/calls/product/get_product");
var update_product_1 = require("../../../../api/calls/product/update_product");
var add_product_variances_1 = require("../../../../api/calls/product/variances/add_product_variances");
var upgradeModalComponent_1 = require("../../../../components/upgradeModalComponent");
var constants_1 = require("../../../../constants/constants");
var routes_1 = require("../../../../constants/routes");
var sanitiseObject_1 = require("../../../../helpers/sanitiseObject");
var category_1 = require("../../../../reducers/slices/categories/category");
var console_1 = require("../../../../reducers/slices/console");
var main_1 = require("../../../../reducers/slices/main");
var get_category_thunk_1 = require("../../../../reducers/slices/products/categories/thunks/get_category_thunk");
var get_product_types_thunk_1 = require("../../../../reducers/slices/products/product_types/thunks/get_product_types_thunk");
var add_product_thunk_1 = require("../../../../reducers/slices/products/thunks/add_product_thunk");
var get_client_tags_thunk_1 = require("../../../../reducers/slices/products/thunks/get_client_tags_thunk");
var get_products_shopify_thunk_1 = require("../../../../reducers/slices/products/thunks/get_products_shopify_thunk");
var client_user_selector_1 = require("../../../../selectors/client_user_selector");
var add_add_ons_1 = __importDefault(require("./components/product_details/add_add_ons"));
var add_tags_1 = __importDefault(require("./components/product_details/add_tags"));
var channels_and_apps_1 = __importDefault(require("./components/product_details/channels_and_apps"));
var connected_channels_1 = __importDefault(require("./components/product_details/connected_channels"));
var product_details_1 = __importDefault(require("./components/product_details/product_details"));
var variance_config_1 = __importDefault(require("./components/product_details/variance_config"));
var moment_1 = __importDefault(require("moment"));
var edit_variants_component_1 = __importDefault(require("./components/product_details/edit_variants_component"));
var get_product_variances_1 = require("../../../../api/calls/product/variances/get_product_variances");
var product_variation_add_ons_1 = __importDefault(require("./components/product_details/product_variation_add_ons"));
var remove_variant_1 = __importDefault(require("./components/product_details/remove_variant"));
var select_variant_1 = __importDefault(require("./components/product_details/select_variant"));
var condiment_groups_component_1 = __importDefault(require("./components/product_details/condiment_groups_component"));
var non_stock_keeping_unit_1 = __importDefault(require("./components/product_details/non_stock_keeping_unit"));
exports.PROMOTION_DURATION = [
    { label: "Unlimited", value: "UNLIMITED" },
    { label: "Fixed", value: "FIXED" },
];
exports.AddOnsTableColumns = [
    {
        displayKey: "loyalty_number",
        label: "Image",
    },
    {
        displayKey: "loyalty_number",
        label: "Price",
    },
    {
        displayKey: "linked",
        label: "Promotional Price",
    },
    {
        displayKey: "member_date",
        label: "Stock Level",
    },
];
var ProductDetailsPage = function () {
    var _a, _b, _c, _d, _e, _f;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _g = (0, react_redux_1.useSelector)(function (state) { return state.categoryState; }), pagination = _g.pagination, loaded = _g.loaded;
    var _h = (0, react_redux_1.useSelector)(function (state) { return state.userState; }), client_token = _h.client_token, user = _h.user;
    var _j = (0, react_redux_1.useSelector)(client_user_selector_1.clientSubsciptionStatusSelector), isUnsubscribed = _j.isUnsubscribed, isFreemiumPlan = _j.isFreemiumPlan;
    var _k = (0, react_redux_1.useSelector)(function (state) { return state.productState; }), products = _k.products, productVariances = _k.productVariances, productsPagination = _k.pagination;
    var product_id = (0, react_router_dom_1.useParams)().product_id;
    var today = (0, moment_1.default)().startOf("day"); // Gets the current date at the start of the day
    var VARIANT = {
        product_id: product_id,
        id: null,
        type: null,
        title: null,
        price: null,
        variations: [],
        add_ons: [],
        status: "AVAILABLE",
        sku: null,
        pid: null,
        on_promotion: false,
        promotion_price: null,
        image_url: null,
    };
    var _l = (0, react_1.useState)(false), isHeroImageLoading = _l[0], setIsHeroImageLoading = _l[1];
    var _m = (0, react_1.useState)(false), isImageListLoading = _m[0], setIsImageListLoading = _m[1];
    var _o = (0, react_1.useState)(false), showSaveChangesLabel = _o[0], setShowSaveChangesLabel = _o[1];
    var _p = (0, react_1.useState)(), lastIndex = _p[0], setLastIndex = _p[1];
    var _q = (0, react_1.useState)(false), refreshTreeItemsData = _q[0], setRefreshTreeItemsData = _q[1];
    var _r = (0, react_1.useState)([]), treeItems = _r[0], setTreeItems = _r[1];
    var _s = (0, react_1.useState)(), rootItem = _s[0], setRootItem = _s[1];
    var _t = (0, react_1.useState)(), selectedItem = _t[0], setSelectedItem = _t[1];
    var _u = (0, react_1.useState)("Save Variances"), buttonTitle = _u[0], setButtonTitle = _u[1];
    var _v = (0, react_1.useState)([]), variances = _v[0], setVariances = _v[1];
    var _w = (0, react_1.useState)([]), condiments = _w[0], setCondiments = _w[1];
    var _x = (0, react_1.useState)(null), varianceEdit = _x[0], setVarianceEdit = _x[1];
    var _y = (0, react_1.useState)({
        _id: "",
        image_url: "",
        image_list: [],
        title: "",
        sub_title: "",
        description: "",
        brand: "",
        manufacturer: "",
        sku: "",
        pid: "",
        quantity_type: "",
        quantity: "",
        cost_price: "0.00",
        price: "0.00",
        recommended: true,
        on_promotion: false,
        vatable: true,
        track_quantity: true,
        notify_when_stock_low: true,
        continue_selling_when_out_of_stock: false,
        promotion_price: "0.00",
        variations: [],
        category_id: "",
        sub_category_id: "",
        status: "",
        type_id: "",
        barcode: "",
        notes: "",
        extra_fields: [],
        add_ons: [],
        tags: [],
        channels: [],
        availability: "ONLINE",
        condiments: [],
        url: "",
        mpn: "",
        ean13: "",
        weight: 0,
        depth: 0,
        height: 0,
        width: 0,
    }), values = _y[0], setValues = _y[1];
    var _showUpgradeModal = function (_) {
        return dispatch((0, main_1.setContentModal)({
            title: constants_1.UPGRADE_MODAL_TITLE,
            content: ((0, jsx_runtime_1.jsx)(upgradeModalComponent_1.UpgradeModalComponent, { message: "Whoa there, superstar! You've maxed out at 10 products on your current plan. Want to move more merch? Time to level up! Upgrade now and transform your store from cozy boutique to mega-mart." })),
        }));
    };
    var productLimitReached = products.length >= Number(process.env.FREEMIUM_PRODUCT_LIMIT);
    var addProduct = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ((isUnsubscribed || isFreemiumPlan) && productLimitReached) {
                        return [2 /*return*/, _showUpgradeModal(null)];
                    }
                    return [4 /*yield*/, dispatch((0, add_product_thunk_1.add_product_thunk)(params))];
                case 1:
                    payload = (_a.sent()).payload;
                    return [2 /*return*/, (payload === null || payload === void 0 ? void 0 : payload.success) && navigate(-1)];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        (0, get_product_variances_1.get_product_variances)({
            product_id: product_id,
        }).then(function (response) {
            if (response === null || response === void 0 ? void 0 : response.success) {
                setVariances(response === null || response === void 0 ? void 0 : response.content);
            }
        });
    }, []);
    (0, react_1.useEffect)(function () {
        (0, get_product_variances_1.get_product_variances)({
            product_id: product_id,
        }).then(function (response) {
            if (response === null || response === void 0 ? void 0 : response.success) {
                setVariances(response === null || response === void 0 ? void 0 : response.content);
                setRefreshTreeItemsData(false);
            }
        });
    }, [refreshTreeItemsData]);
    (0, react_1.useEffect)(function () {
        setTreeItems(varianceData(variances));
    }, [variances, refreshTreeItemsData]);
    (0, react_1.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)("Product Details"));
        if (product_id && client_token) {
            getSelectedProduct();
        }
        if (client_token) {
            getProductTypes();
        }
    }, [client_token, product_id]);
    (0, react_1.useEffect)(function () {
        if (client_token) {
            dispatch((0, get_products_shopify_thunk_1.get_products_thunk)(__assign({}, productsPagination)));
        }
    }, [client_token]);
    var getSelectedProduct = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, get_product_1.get_product)({ _id: product_id })];
                case 1:
                    response = _a.sent();
                    if (response.success) {
                        setValues(response.content);
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong when retrieving the selected product.", messages: [response.message] }));
                        setTimeout(function () {
                            navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.PRODUCT_LIST_ROUTE));
                        }, 2000);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getProductTypes = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch((0, get_product_types_thunk_1.get_product_types_thunk)(""))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var refreshData = function () {
        setRefreshTreeItemsData(true);
    };
    (0, react_1.useEffect)(function () {
        if (!loaded && client_token) {
            dispatch((0, category_1.setLoaded)(true));
            dispatch((0, get_category_thunk_1.get_category_thunk)(__assign({}, pagination)));
            dispatch((0, get_client_tags_thunk_1.get_client_tags_thunk)({}));
        }
    }, [client_token]);
    var updateValues = function (prop, value) {
        var _a;
        setValues(__assign(__assign({}, values), (_a = {}, _a[prop] = value, _a)));
    };
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        if ((_a = values === null || values === void 0 ? void 0 : values.image_list) === null || _a === void 0 ? void 0 : _a.length) {
            var lastIndex_1 = (_b = values === null || values === void 0 ? void 0 : values.image_list) === null || _b === void 0 ? void 0 : _b.lastIndexOf(values === null || values === void 0 ? void 0 : values.image_list[((_c = values === null || values === void 0 ? void 0 : values.image_list) === null || _c === void 0 ? void 0 : _c.length) - 1]);
            setLastIndex(lastIndex_1);
        }
    }, [(_a = values === null || values === void 0 ? void 0 : values.image_list) === null || _a === void 0 ? void 0 : _a.length]);
    var uploadImage = function (file, file_name, tag) {
        if (tag === "Hero") {
            setIsHeroImageLoading(true);
            setIsImageListLoading(false);
        }
        else {
            setIsImageListLoading(true);
            setIsHeroImageLoading(false);
        }
        (0, upload_file_1.upload_file)({
            file: file,
            file_name: file_name,
            description: "Letstrade product images",
            type: "IMAGE",
            category: "PRODUCTS",
        }).then(function (res) {
            var _a;
            console.log(res);
            if (res === null || res === void 0 ? void 0 : res.success) {
                if (tag === "Hero") {
                    setIsHeroImageLoading(false);
                    setValues(__assign(__assign({}, values), { image_url: res.content.location }));
                }
                else {
                    setIsHeroImageLoading(false);
                    setIsImageListLoading(false);
                    setValues(__assign(__assign({}, values), { image_list: __spreadArray(__spreadArray([], values.image_list, true), [{ url: res.content.location, order: ((_a = values.image_list) === null || _a === void 0 ? void 0 : _a.length) + 1 }], false) }));
                }
            }
            else {
                setIsHeroImageLoading(false);
                setIsImageListLoading(false);
            }
        });
    };
    var swapElements = function (array, index1, index2) {
        var _a;
        _a = [array[index2], array[index1]], array[index1] = _a[0], array[index2] = _a[1];
    };
    var removeVariantModal = function (selectedItem) {
        return dispatch((0, main_1.setContentModal)({
            title: "Remove Variant",
            content: (0, jsx_runtime_1.jsx)(remove_variant_1.default, { selectedItem: selectedItem, onTaskComplete: refreshData }),
        }));
    };
    var variantAddOnsModal = function (selectedItem) {
        return dispatch((0, main_1.setContentModal)({
            title: "Add Ons",
            content: (0, jsx_runtime_1.jsx)(product_variation_add_ons_1.default, { selectedItem: selectedItem, onTaskComplete: refreshData }),
        }));
    };
    var sanitiseVariances = function (items) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        var variances = [];
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            var obj = {
                ref: (_a = item._id) !== null && _a !== void 0 ? _a : item.ref,
                product_id: product_id,
                variations: [],
                add_ons: [],
                status: (_c = (_b = item.data) === null || _b === void 0 ? void 0 : _b.status) !== null && _c !== void 0 ? _c : item.status,
                type: (_e = (_d = item.data) === null || _d === void 0 ? void 0 : _d.type) !== null && _e !== void 0 ? _e : item.type,
                title: (_g = (_f = item.data) === null || _f === void 0 ? void 0 : _f.title) !== null && _g !== void 0 ? _g : item.title,
                price: (_j = (_h = item.data) === null || _h === void 0 ? void 0 : _h.price) !== null && _j !== void 0 ? _j : item.price,
                sku: (_l = (_k = item.data) === null || _k === void 0 ? void 0 : _k.sku) !== null && _l !== void 0 ? _l : item.sku,
                pid: (_o = (_m = item.data) === null || _m === void 0 ? void 0 : _m.pid) !== null && _o !== void 0 ? _o : item.pid,
                image_url: (_q = (_p = item.data) === null || _p === void 0 ? void 0 : _p.image_url) !== null && _q !== void 0 ? _q : item.image_url,
                on_promotion: (_s = (_r = item.data) === null || _r === void 0 ? void 0 : _r.on_promotion) !== null && _s !== void 0 ? _s : item.on_promotion,
                promotion_price: (_u = (_t = item.data) === null || _t === void 0 ? void 0 : _t.promotion_price) !== null && _u !== void 0 ? _u : item.promotion_price,
                is_default: (_w = (_v = item.data) === null || _v === void 0 ? void 0 : _v.is_default) !== null && _w !== void 0 ? _w : item.is_default,
            };
            if (item.items && item.items.length > 0) {
                obj.variations = sanitiseVariances(item.items);
            }
            variances.push(obj);
        }
        return variances;
    };
    var deleteItem = function (productVariances, itemRef) {
        for (var i = 0; i < productVariances.length; i++) {
            var item = productVariances[i];
            if ((item === null || item === void 0 ? void 0 : item.ref) === itemRef) {
                productVariances.splice(i, 1);
                return;
            }
            else {
                if (item.variations && item.variations.length > 0) {
                    deleteItem(item.variations, itemRef);
                }
            }
        }
    };
    var loopRoot = function (productVariances, ref) {
        for (var _i = 0, productVariances_1 = productVariances; _i < productVariances_1.length; _i++) {
            var root = productVariances_1[_i];
            if (root.ref === ref) {
                return root;
            }
            else {
                if (root.variations && root.variations.length > 0) {
                    var p = loopChild(root.variations, ref, root);
                    if (p) {
                        return p;
                    }
                }
            }
        }
    };
    var loopChild = function (rootVariances, ref, root) {
        for (var _i = 0, rootVariances_1 = rootVariances; _i < rootVariances_1.length; _i++) {
            var child = rootVariances_1[_i];
            if (child.ref === ref) {
                return root;
            }
            else {
                if (child.variations && child.variations.length > 0) {
                    loopChild(child.variations, ref, root);
                }
            }
        }
    };
    var getRootItem = function (productVariances, ref, parent) {
        var p = null;
        for (var _i = 0, productVariances_2 = productVariances; _i < productVariances_2.length; _i++) {
            var productVariance = productVariances_2[_i];
            p = productVariance;
            if (productVariance.ref === ref) {
                return p;
            }
            else {
                if (productVariance.variations && productVariance.variations.length) {
                    p = getRootItem(productVariance.variations, ref, p);
                }
            }
        }
    };
    var varianceData = function (productVariances) {
        var _a, _b, _c, _d, _e;
        var items = [];
        var _loop_1 = function (productVariance) {
            var data = {
                _id: productVariance === null || productVariance === void 0 ? void 0 : productVariance.ref,
                data: productVariance,
                content: ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-row gap-3" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "flex-1" }, { children: productVariance === null || productVariance === void 0 ? void 0 : productVariance.title })), ((_a = productVariance === null || productVariance === void 0 ? void 0 : productVariance.add_ons) === null || _a === void 0 ? void 0 : _a.length) === 0 && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex items-center pt-[2px]" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex items-center px-1 h-[22px] bg-black text-white text-xs rounded-md bold", onClick: function () {
                                            var foundRoot = loopRoot(variances, productVariance === null || productVariance === void 0 ? void 0 : productVariance.ref);
                                            variantAddOnsModal(__assign(__assign({}, productVariance), { root: foundRoot }));
                                        } }, { children: "Add Ons" })) }))), ((_b = productVariance === null || productVariance === void 0 ? void 0 : productVariance.add_ons) === null || _b === void 0 ? void 0 : _b.length) > 0 && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-row items-center gap-2 justify-center" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: ((_c = productVariance === null || productVariance === void 0 ? void 0 : productVariance.add_ons) === null || _c === void 0 ? void 0 : _c.length) + "".concat(((_d = productVariance === null || productVariance === void 0 ? void 0 : productVariance.add_ons) === null || _d === void 0 ? void 0 : _d.length) > 1 ? " add ons attached" : " add on attached"), size: "small" }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LinkButtonControl, { label: "View", size: "small", textColor: "text-blue-400", onClick: function () {
                                                var foundRoot = loopRoot(variances, productVariance === null || productVariance === void 0 ? void 0 : productVariance.ref);
                                                variantAddOnsModal(__assign(__assign({}, productVariance), { root: foundRoot }));
                                            } })] }))), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.IconButtonControl, { size: "2xsmall", icon: pro_solid_svg_icons_1.faPen, backgroundColor: "bg-blue-400", iconColor: "text-white", borderColor: "border-transparent", onClick: function () {
                                            var foundRoot = loopRoot(variances, productVariance === null || productVariance === void 0 ? void 0 : productVariance.ref);
                                            setVarianceEdit(__assign(__assign({}, productVariance), { root: foundRoot }));
                                            setButtonTitle("Update Variance");
                                        } }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.IconButtonControl, { size: "2xsmall", icon: pro_solid_svg_icons_1.faTrash, backgroundColor: "bg-red-400", iconColor: "text-white", borderColor: "border-transparent", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                            var foundRoot;
                                            return __generator(this, function (_a) {
                                                deleteItem(productVariance, productVariance === null || productVariance === void 0 ? void 0 : productVariance.ref);
                                                foundRoot = loopRoot(variances, productVariance === null || productVariance === void 0 ? void 0 : productVariance.ref);
                                                removeVariantModal(__assign(__assign({}, productVariance), { root: foundRoot }));
                                                return [2 /*return*/];
                                            });
                                        }); } }) }), (0, jsx_runtime_1.jsx)("div", {})] })), (0, jsx_runtime_1.jsx)("div", {})] }))),
            };
            if (productVariance.variations && ((_e = productVariance.variations) === null || _e === void 0 ? void 0 : _e.length)) {
                data.items = varianceData(productVariance.variations);
            }
            items.push(data);
        };
        for (var _i = 0, productVariances_3 = productVariances; _i < productVariances_3.length; _i++) {
            var productVariance = productVariances_3[_i];
            _loop_1(productVariance);
        }
        return items;
    };
    var mutateSelectedTreeItem = function (treeItems, selectedItem, modifiedItem) {
        for (var i = 0; i < treeItems.length; i++) {
            var item = treeItems[i];
            if ((item === null || item === void 0 ? void 0 : item._id) === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem._id)) {
                treeItems[i] = modifiedItem;
                break;
            }
            else {
                if (item.items && item.items.length) {
                    mutateSelectedTreeItem(item.items, selectedItem, modifiedItem);
                }
            }
        }
        return treeItems;
    };
    var enAbleSaveButton = true;
    if (!((_b = values === null || values === void 0 ? void 0 : values.status) === null || _b === void 0 ? void 0 : _b.length)) {
        enAbleSaveButton = false;
    }
    if (!((_c = values === null || values === void 0 ? void 0 : values.title) === null || _c === void 0 ? void 0 : _c.length)) {
        enAbleSaveButton = false;
    }
    if (!((_d = values === null || values === void 0 ? void 0 : values.pid) === null || _d === void 0 ? void 0 : _d.length)) {
        enAbleSaveButton = false;
    }
    if (!((_e = values === null || values === void 0 ? void 0 : values.sku) === null || _e === void 0 ? void 0 : _e.length)) {
        enAbleSaveButton = false;
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-2" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex justify-between items-center gap-4" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-row" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { iconColor: "text-black", label: "Back To Products", size: "xsmall", startIcon: pro_solid_svg_icons_1.faChevronLeft, backgroundColor: "bg-transparent", textColor: "text-black", onClick: function () {
                                navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.PRODUCT_LIST_ROUTE));
                            } }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "w-[100px]" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: product_id ? "Update" : "Save", enabled: enAbleSaveButton, size: "medium", backgroundColor: "bg-primary", textColor: "text-white", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                var params, transformedCondiments, response;
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            values.variations = [];
                                            if ((user === null || user === void 0 ? void 0 : user.role) !== "ADMIN") {
                                                values.availability = "OFFLINE";
                                                values.branch_id_list = user === null || user === void 0 ? void 0 : user.manager_of;
                                            }
                                            params = (0, sanitiseObject_1.sanitiseObject)(__assign({}, values));
                                            if (!!values._id) return [3 /*break*/, 2];
                                            return [4 /*yield*/, addProduct(params)];
                                        case 1:
                                            _b.sent();
                                            return [3 /*break*/, 4];
                                        case 2:
                                            transformedCondiments = (_a = params === null || params === void 0 ? void 0 : params.condiments) === null || _a === void 0 ? void 0 : _a.map(function (condiment) {
                                                var defaultProduct = condiment.product_list.find(function (product) { return product.default; });
                                                var requiredProducts = condiment.product_list.filter(function (product) { return product.required; }).map(function (product) { return product._id; });
                                                return {
                                                    condiment_id: condiment._id,
                                                    default_product_id: defaultProduct ? defaultProduct._id : null,
                                                    required_products: requiredProducts,
                                                };
                                            });
                                            params.condiments = transformedCondiments;
                                            return [4 /*yield*/, (0, update_product_1.update_product)(params)];
                                        case 3:
                                            response = _b.sent();
                                            if (response.success) {
                                                dispatch((0, main_1.setMessageModal)({ title: "Success...", messages: [response.message] }));
                                            }
                                            else {
                                                dispatch((0, main_1.setMessageModal)({ title: "Something went wrong when updating product details!", messages: [response.message] }));
                                            }
                                            _b.label = 4;
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); } }) }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col lg:flex-row gap-4" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex-1 flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsx)(product_details_1.default, { values: values, updateValues: updateValues }), (0, jsx_runtime_1.jsx)(add_add_ons_1.default, { values: values, setValues: setValues }), (0, jsx_runtime_1.jsx)(condiment_groups_component_1.default, { values: values, setValues: setValues }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "grid grid-cols-1 divide-x shadow-md gap-4" }, { children: (0, jsx_runtime_1.jsxs)(doshx_controls_web_1.BoxControl, __assign({ backgroundColor: "bg-white", variant: "filled", className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Promotions", bold: true, textColor: "text-black" }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "grid grid-cols-2 gap-2 items-center" }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.CheckboxControl, { label: "On promotion", value: values === null || values === void 0 ? void 0 : values.on_promotion, onChange: function (v) {
                                                        updateValues("on_promotion", v);
                                                    } }) }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "grid grid-cols-3 gap-2 bg-white" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.TextInputControl, { label: "Promotional Price", type: "number", borderColor: "border-borders", value: values === null || values === void 0 ? void 0 : values.promotion_price, errorText: (values === null || values === void 0 ? void 0 : values.on_promotion) && parseInt(values.promotion_price) <= 0 && "promotional price is required.", onChange: function (v) {
                                                    updateValues("promotion_price", v);
                                                } }) }))] })) })), (0, jsx_runtime_1.jsxs)(doshx_controls_web_1.BoxControl, __assign({ backgroundColor: "bg-white", variant: "filled", className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsx)(select_variant_1.default, { treeItems: treeItems, product_id: product_id, onTaskComplete: refreshData }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.DividerControl, {}), (0, jsx_runtime_1.jsx)(edit_variants_component_1.default, { selectedItem: varianceEdit, onCreate: function (newNode) {
                                            var newVariances = __spreadArray([newNode], variances, true);
                                            setVariances(newVariances);
                                        }, onTaskComplete: refreshData })] })), (0, jsx_runtime_1.jsxs)(doshx_controls_web_1.BoxControl, __assign({ backgroundColor: "bg-white", variant: "filled", className: "flex flex-col gap-4 mb-8" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: (treeItems === null || treeItems === void 0 ? void 0 : treeItems.length) > 0 ? "".concat(values === null || values === void 0 ? void 0 : values.title, " Product Variations") : "Build Variations for ".concat(values === null || values === void 0 ? void 0 : values.title, " Product"), bold: true, textColor: "text-black" }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.TreeControl, { onChange: function (items) {
                                            setTreeItems(items);
                                        }, items: treeItems, onNodeClick: function (selectedItem, rootItem) {
                                            setRootItem(rootItem);
                                            setSelectedItem(selectedItem);
                                            // editVariantModal(selectedItem);
                                            // setShowTable(false);
                                            // setButtonTitle("Update Variance");
                                            // setValues({
                                            //   ...values,
                                            //   variations: [
                                            //     {
                                            //       _id: selectedItem._id,
                                            //       product_id,
                                            //       client_id: user?.client_id,
                                            //       type: selectedItem?.data?.type ?? selectedItem.type,
                                            //       title: selectedItem?.data?.title ?? selectedItem.title,
                                            //       price: selectedItem?.data?.price ?? selectedItem.price,
                                            //       items: selectedItem?.data?.variations ?? selectedItem.variations,
                                            //       status: selectedItem?.data?.status ?? selectedItem.status,
                                            //       sku: selectedItem?.data?.sku ?? selectedItem.sku,
                                            //       pid: selectedItem?.data?.pid ?? selectedItem.pid,
                                            //       image_url: selectedItem?.data?.image_url ?? selectedItem.image_url,
                                            //     },
                                            //   ],
                                            // });
                                        } }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-row items-center justify-end" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: "Save", size: "small", startIcon: pro_solid_svg_icons_1.faSave, backgroundColor: "bg-primary", textColor: "text-white", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                var treeItemsWithoutContent, sanitisedTreeItems, response;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0:
                                                            treeItemsWithoutContent = treeItems === null || treeItems === void 0 ? void 0 : treeItems.filter(function (treeItem) { return !treeItem.hasOwnProperty("content"); });
                                                            sanitisedTreeItems = sanitiseVariances(treeItemsWithoutContent);
                                                            return [4 /*yield*/, (0, add_product_variances_1.add_product_variances)(sanitisedTreeItems)];
                                                        case 1:
                                                            response = _a.sent();
                                                            if (response.success) {
                                                                setRefreshTreeItemsData(true);
                                                                dispatch((0, main_1.setMessageModal)({ title: "Success...", messages: [response.message] }));
                                                            }
                                                            else {
                                                                dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                                                            }
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); } }) }))] }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex-1 flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsxs)(doshx_controls_web_1.BoxControl, __assign({ backgroundColor: "bg-white", variant: "filled", className: "" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Product Media", bold: true, textColor: "text-black" }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.BoxControl, __assign({ className: "", variant: "filled" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "grid grid-cols-2 justify-self-start items-center gap-2" }, { children: [isHeroImageLoading ? ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.CircularLoaderControl, { size: "xsmall" })) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex items-center justify-center p-2" }, { children: (values === null || values === void 0 ? void 0 : values.image_url) && ((0, jsx_runtime_1.jsx)("img", { alt: "gallery", className: "w-64 h-64 aspect-square rounded-lg border border-gray-300 border-dashed p-2", src: values === null || values === void 0 ? void 0 : values.image_url })) }))), (0, jsx_runtime_1.jsx)("div", __assign({ className: "" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.FileInputControl, { label: "Upload Product Image", size: "medium", startIcon: pro_solid_svg_icons_1.faFileArrowUp, onChange: function (f) {
                                                            uploadImage(f, f.name, "Hero");
                                                        }, colors: {
                                                            borderColor: "border-gray-400",
                                                        } }) }))] })) }))] })), (0, jsx_runtime_1.jsxs)(doshx_controls_web_1.BoxControl, __assign({ backgroundColor: "bg-white", variant: "filled", className: "" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Image List", bold: true, textColor: "text-black" }), isImageListLoading && (0, jsx_runtime_1.jsx)(doshx_controls_web_1.CircularLoaderControl, { size: "xsmall" }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-wrap items-center gap-2 pt-4" }, { children: [(_f = values === null || values === void 0 ? void 0 : values.image_list) === null || _f === void 0 ? void 0 : _f.map(function (x, i) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex relative justify-center" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "flex justify-between items-center border w-36 aspect-square rounded-lg p-2" }, { children: (0, jsx_runtime_1.jsx)("img", { alt: "gallery", className: "rounded-lg object-cover object-center", src: x.url }) }), x === null || x === void 0 ? void 0 : x._id), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-2 absolute -top-4" }, { children: [i !== 0 && ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.IconButtonControl, { backgroundColor: "bg-primary", borderColor: "border-transparent", iconColor: "text-white", icon: pro_solid_svg_icons_1.faArrowLeft, size: "xsmall", shape: "circle", onClick: function () {
                                                                    setShowSaveChangesLabel(true);
                                                                    swapElements(values === null || values === void 0 ? void 0 : values.image_list, i, i - 1);
                                                                    setValues(__assign(__assign({}, values), { image_list: values === null || values === void 0 ? void 0 : values.image_list }));
                                                                } })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.IconButtonControl, { backgroundColor: "bg-primary", borderColor: "border-transparent", iconColor: "text-white", icon: pro_solid_svg_icons_1.faTimes, size: "xsmall", shape: "circle", onClick: function () {
                                                                    var _a;
                                                                    var updatedList = (_a = values === null || values === void 0 ? void 0 : values.image_list) === null || _a === void 0 ? void 0 : _a.filter(function (image, index) { return index !== i; });
                                                                    setShowSaveChangesLabel(true);
                                                                    setValues(__assign(__assign({}, values), { image_list: updatedList }));
                                                                } }), i !== lastIndex && ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.IconButtonControl, { backgroundColor: "bg-primary", borderColor: "border-transparent", iconColor: "text-white", icon: pro_solid_svg_icons_1.faArrowRight, size: "xsmall", shape: "circle", onClick: function () {
                                                                    setShowSaveChangesLabel(true);
                                                                    swapElements(values === null || values === void 0 ? void 0 : values.image_list, i, i + 1);
                                                                    setValues(__assign(__assign({}, values), { image_list: values === null || values === void 0 ? void 0 : values.image_list }));
                                                                } }))] }))] }))); }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-row items-center gap-4" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "w-[100px] mt-8" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { iconColor: "text-white", label: "Save", size: "medium", backgroundColor: "bg-primary", textColor: "text-white", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                                var params, response;
                                                                return __generator(this, function (_a) {
                                                                    switch (_a.label) {
                                                                        case 0:
                                                                            values.variations = [];
                                                                            params = (0, sanitiseObject_1.sanitiseObject)(__assign({}, values));
                                                                            return [4 /*yield*/, (0, update_product_1.update_product)(params)];
                                                                        case 1:
                                                                            response = _a.sent();
                                                                            if (response.success) {
                                                                                setShowSaveChangesLabel(false);
                                                                                dispatch((0, main_1.setMessageModal)({ title: "Success...", messages: [response.message] }));
                                                                            }
                                                                            return [2 /*return*/];
                                                                    }
                                                                });
                                                            }); } }) })), showSaveChangesLabel && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "mt-8" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Save Changes...", size: "xsmall", textColor: "text-red-600" }) })))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "w-full mt-2" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.FileInputControl, { label: "Upload Image", size: "medium", startIcon: pro_solid_svg_icons_1.faFileArrowUp, onChange: function (f) {
                                                        setShowSaveChangesLabel(true);
                                                        uploadImage(f, f.name);
                                                    }, colors: {
                                                        borderColor: "border-gray-400",
                                                    } }) }))] }))] })), (0, jsx_runtime_1.jsx)(variance_config_1.default, { values: values, setValues: setValues, updateValues: updateValues }), (0, jsx_runtime_1.jsx)(connected_channels_1.default, { values: values, updateValues: updateValues }), (0, jsx_runtime_1.jsx)(channels_and_apps_1.default, { values: values, setValues: setValues, updateValues: updateValues }), (0, jsx_runtime_1.jsx)(add_tags_1.default, { values: values, setValues: setValues }), (0, jsx_runtime_1.jsx)(non_stock_keeping_unit_1.default, { values: values })] }))] }))] })));
};
exports.ProductDetailsPage = ProductDetailsPage;
